import React, { useCallback, useEffect, useState } from 'react';
import RegalosPuntos from './RegalosPuntos';
import ProductosPuntos from './ProductosPuntos';
import { puntosApi, asList, cardStyle, pillStyle } from './puntosApi';
import { Estrella } from '../../publico/Iconos';

const TABS = [
    { id: 'resumen', label: 'Resumen' },
    { id: 'regalos', label: 'Regalos' },
    { id: 'productos', label: 'Productos' },
    { id: 'clientes', label: 'Clientes' },
    { id: 'canjes', label: 'Canjes' },
];

const fmtDateTime = (iso) => new Date(iso).toLocaleString('es-EC', { dateStyle: 'short', timeStyle: 'short' });

const Kpi = ({ label, value, tint }) => (
    <div style={{ ...cardStyle, background: tint || '#fff' }}>
        <div style={{ fontSize: '2rem', fontWeight: 800, color: 'var(--primary-color)', lineHeight: 1.1 }}>{value}</div>
        <div style={{ color: '#6b7280', fontSize: '0.9rem' }}>{label}</div>
    </div>
);

const Resumen = ({ summary }) => {
    if (!summary) return <p>Cargando…</p>;
    return (
        <div style={{ display: 'grid', gap: '1.5rem' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '1rem' }}>
                <Kpi label="Puntos vigentes de clientes" value={summary.points_balance} tint="var(--sidebar-bg)" />
                <Kpi label="Puntos entregados (histórico)" value={summary.points_earned} />
                <Kpi label="Puntos canjeados" value={summary.points_redeemed} />
                <Kpi label="Clientes con puntos" value={summary.customers_with_points} />
                <Kpi label="Regalos entregados hoy" value={summary.gifts_today} tint="#e6f6ee" />
                <Kpi label="Regalos entregados (total)" value={summary.gifts_total} />
            </div>
            <div style={cardStyle}>
                <h3 style={{ marginTop: 0, color: 'var(--primary-color)' }}>Regalos reclamados por tipo</h3>
                {summary.gifts_by_reward.length === 0 ? <p style={{ color: '#6b7280' }}>Todavía no se han reclamado regalos.</p> : (
                    summary.gifts_by_reward.map((g) => (
                        <div key={g.name} style={{ display: 'flex', justifyContent: 'space-between', padding: '0.5rem 0', borderBottom: '1px solid #f3e3e3' }}>
                            <span>{g.name}</span><strong>{g.count}</strong>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

const Clientes = ({ summary }) => {
    const [cedula, setCedula] = useState('');
    const [detail, setDetail] = useState(null);
    const [error, setError] = useState('');

    const search = async (value) => {
        setError('');
        try {
            const res = await puntosApi.lookup(value);
            setDetail(res.data);
        } catch (err) {
            setDetail(null);
            setError(err.response?.data?.error || 'No se pudo consultar.');
        }
    };

    return (
        <div style={{ display: 'grid', gap: '1.5rem' }}>
            <div style={cardStyle}>
                <form onSubmit={(e) => { e.preventDefault(); search(cedula); }} style={{ display: 'flex', gap: '0.5rem' }}>
                    <input className="form-control" placeholder="Buscar cliente por cédula" value={cedula} inputMode="numeric"
                        onChange={(e) => setCedula(e.target.value.replace(/\D/g, ''))} />
                    <button className="btn btn-primary" type="submit">Buscar</button>
                </form>
                {error && <p style={{ color: '#9b1c1c', marginBottom: 0 }}>{error}</p>}
                {detail && (
                    <div style={{ marginTop: '1rem' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <strong style={{ color: 'var(--primary-color)' }}>{detail.customer.full_name}</strong>
                                <div style={{ color: '#6b7280', fontSize: '0.9rem' }}>C.I. {detail.customer.cedula}</div>
                            </div>
                            <span style={{ ...pillStyle, fontSize: '1.1rem' }}><Estrella size={13} style={{ verticalAlign: '-2px', color: '#d9a441' }} /> {detail.points_balance}</span>
                        </div>
                        <table className="table" style={{ marginTop: '0.75rem' }}>
                            <tbody>
                                {detail.history.map((h, i) => (
                                    <tr key={i}>
                                        <td>{fmtDateTime(h.created_at)}</td>
                                        <td>{h.reason}</td>
                                        <td style={{ textAlign: 'right', fontWeight: 700, color: h.points_change >= 0 ? '#1f6b45' : 'var(--primary-color)' }}>
                                            {h.points_change >= 0 ? '+' : ''}{h.points_change}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            <div style={cardStyle}>
                <h3 style={{ marginTop: 0, color: 'var(--primary-color)' }}>Ranking de clientes</h3>
                {!summary ? <p>Cargando…</p> : summary.top_customers.length === 0 ? <p style={{ color: '#6b7280' }}>Aún no hay clientes con puntos.</p> : (
                    <div style={{ overflowX: 'auto' }}>
                        <table className="table">
                            <thead><tr><th>#</th><th>Cliente</th><th>Cédula</th><th>Saldo</th><th>Ganados</th><th>Canjeados</th></tr></thead>
                            <tbody>
                                {summary.top_customers.map((c, i) => (
                                    <tr key={c.id} style={{ cursor: 'pointer' }} onClick={() => c.cedula && search(c.cedula)}>
                                        <td><strong style={{ color: i < 3 ? 'var(--primary-color)' : 'inherit' }}>{i + 1}</strong></td>
                                        <td>{c.full_name}</td>
                                        <td>{c.cedula || '—'}</td>
                                        <td><span style={pillStyle}><Estrella size={13} style={{ verticalAlign: '-2px', color: '#d9a441' }} /> {c.points_balance}</span></td>
                                        <td>{c.total_points_earned}</td>
                                        <td>{c.total_points_redeemed}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

const Canjes = () => {
    const today = new Date().toLocaleDateString('en-CA'); // YYYY-MM-DD en hora local
    const [start, setStart] = useState(today);
    const [end, setEnd] = useState(today);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const res = await puntosApi.redemptions({ start, end });
            setRows(asList(res.data));
        } catch (err) {
            console.error('[Puntos] Error cargando canjes', err);
        } finally {
            setLoading(false);
        }
    }, [start, end]);

    useEffect(() => { load(); }, [load]);

    return (
        <div style={cardStyle}>
            <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'end', flexWrap: 'wrap', marginBottom: '1rem' }}>
                <div><label>Desde</label><input type="date" className="form-control" value={start} onChange={(e) => setStart(e.target.value)} /></div>
                <div><label>Hasta</label><input type="date" className="form-control" value={end} onChange={(e) => setEnd(e.target.value)} /></div>
                <strong style={{ marginLeft: 'auto', color: 'var(--primary-color)' }}>{rows.length} regalo(s) entregado(s)</strong>
            </div>
            {loading ? <p>Cargando…</p> : (
                <div style={{ overflowX: 'auto' }}>
                    <table className="table">
                        <thead><tr><th>Fecha</th><th>Regalo</th><th>Cliente</th><th>Cédula</th><th>Puntos</th><th>Caja</th><th>Entregó</th></tr></thead>
                        <tbody>
                            {rows.length === 0 && <tr><td colSpan="7">Sin canjes en este rango.</td></tr>}
                            {rows.map((r) => (
                                <tr key={r.id}>
                                    <td>{fmtDateTime(r.created_at)}</td>
                                    <td>{r.reward_name}</td>
                                    <td>{r.customer_name}</td>
                                    <td>{r.customer_cedula}</td>
                                    <td>-{r.points_spent}</td>
                                    <td>{r.is_feria ? 'Feria' : 'Local'}</td>
                                    <td>{r.redeemed_by || '—'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

const Puntos = () => {
    const [tab, setTab] = useState('resumen');
    const [summary, setSummary] = useState(null);

    useEffect(() => {
        if (tab === 'resumen' || tab === 'clientes') {
            puntosApi.summary()
                .then((res) => setSummary(res.data))
                .catch((err) => console.error('[Puntos] Error cargando resumen', err));
        }
    }, [tab]);

    return (
        <div className="page-container">
            <div className="page-header">
                <h2>Puntos y Regalos</h2>
            </div>
            <div style={{ display: 'flex', gap: '10px', overflowX: 'auto', paddingBottom: '10px', marginBottom: '20px', borderBottom: '1px solid #e2e8f0' }}>
                {TABS.map((t) => (
                    <button key={t.id} className={`btn ${tab === t.id ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setTab(t.id)}>
                        {t.label}
                    </button>
                ))}
            </div>
            {tab === 'resumen' && <Resumen summary={summary} />}
            {tab === 'regalos' && <RegalosPuntos />}
            {tab === 'productos' && <ProductosPuntos />}
            {tab === 'clientes' && <Clientes summary={summary} />}
            {tab === 'canjes' && <Canjes />}
        </div>
    );
};

export default Puntos;
